/* @flow */

import * as React from 'react';
import {Body} from 'shells/typography';
import {FooterBar} from 'shells/modal';
import {Button} from 'shells/button';
import {Link} from 'shells/link';
import {FeatureUsage} from 'shells/limits';

import './feature-limits-modal-content.css';

type Props = {
    currentPlanLimit: ?number,
    currentPlanName: string,
    currentUsage: number,
    humanReadableType: string,
    upgradePlanName: string,
    upgradePlanLimit: ?number,
    onClose: () => void,
};

export function FeatureLimitsModalContent(props: Props) {
    const displayString =
        props.currentPlanLimit === 1
            ? props.humanReadableType.slice(0, props.humanReadableType.length - 1)
            : props.humanReadableType;
    const verb = props.currentPlanLimit === 1 ? 'is' : 'are';

    return (
        <>
            <Body>
                You’ve created {props.currentUsage} out of the {props.currentPlanLimit}{' '}
                {displayString} that {verb} included in your current plan, {props.currentPlanName}.
                If you need to create more {props.humanReadableType} or access additional features,
                you can upgrade to {props.upgradePlanName} or explore our other plan options.
            </Body>
            <div styleName='feature-usage-container'>
                <FeatureUsage
                    currentUsage={props.currentUsage}
                    currentPlanMaxUsage={props.currentPlanLimit}
                    nextPlanMaxUsage={props.upgradePlanLimit}
                />
            </div>
            <FooterBar
                left={
                    <Button size='big' onClick={props.onClose} variant='text-secondary'>
                        Not right now
                    </Button>
                }
                right={
                    <Link size='big' newTab={true} href='/setup/billing' variant='button-primary'>
                        See upgrade options
                    </Link>
                }
            />
        </>
    );
}
